import React, { useCallback } from 'react';
import { Box, Flex, Icon } from '@qga/roo-ui/components';

import Button from '@/components/Button';
import Heading from '@/components/Heading';
import Text from '@/components/Text';
import useCallCentreWorkingStatus from '@/hooks/useCallCentreWorkingStatus';
import { LIVE_CHAT_HOURS } from '../contants';
import useLiveAgent from './hooks/useLiveAgent';

const LiveChat = () => {
  const { isLiveChatOn } = useCallCentreWorkingStatus();
  const liveChatOnlineElement = 'liveChatOnline';
  const liveChatOfflineElement = 'liveChatOffline';

  const { startChat, hasLoadingError } = useLiveAgent({
    liveChatOnlineElement,
    liveChatOfflineElement,
  });

  const handleStartChatLinkClick = useCallback(() => {
    startChat();
  }, [startChat]);

  return (
    <Flex alignItems="flex-start">
      <Box>
        <Icon name="liveChat" size={[22, null, 36]} />
      </Box>
      <Flex ml="2" pt={[null, null, 2]} flexDirection="column">
        <Heading.h4>Chat with us online</Heading.h4>
        <Text bold mt="2">
          Available {LIVE_CHAT_HOURS}
        </Text>
        <div
          id="liveChatOnline"
          data-testid="liveChatOnline"
          style={{ display: 'none' }}
        >
          <Flex my="4">
            <Icon name="circle" color="icon.success" mr="1" />
            Available
          </Flex>
          <Flex>
            <Button
              dialogue
              data-testid="ONLINE-CHAT"
              onClick={handleStartChatLinkClick}
            >
              Start Live Chat
            </Button>
          </Flex>
        </div>
        <div
          id="liveChatOffline"
          data-testid="liveChatOffline"
          style={{ display: `${hasLoadingError ? 'unset' : 'none'}` }}
        >
          <Flex mt="4">
            <Icon
              name="circle"
              color={isLiveChatOn ? 'icon.warning' : 'icon.standAlone'}
              mr="1"
            />
            <Text>{isLiveChatOn ? 'Busy' : 'Not available'}</Text>
          </Flex>
        </div>
      </Flex>
    </Flex>
  );
};

export default LiveChat;
